<template>
  <div class="card-dashboard">
    <header class="card-header">
      <b-input v-if="editing" v-model="newValue" @blur="stopEditing" ref="input" />
      <p v-else @click="startEditing" class="card-header-title">{{ title }}</p>
      <div class="card-header-period">
        <slot name="period"></slot>
      </div>
    </header>
    <div :class="{ 'is-large': large }" class="card-content">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardDashboard',
  props: {
    title: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    },
    canEditTitle: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    editing: false,
    newValue: null
  }),
  methods: {
    startEditing() {
      if (this.canEditTitle) {
        this.newValue = this.title
        this.editing = true
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    stopEditing() {
      this.editing = false
      this.$emit('update:title', this.newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  background: #e9e9e9;

  .control {
    display: flex;
    align-items: center;
  }

  &-title {
    flex: 1;
    padding: 0.5rem;
  }
  &-period {
    padding: 0.35rem 0.75rem;
    display: flex;
    justify-content: space-between;
  }
}
.card-dashboard {
  margin-bottom: 1rem;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  &:last-child {
    margin-bottom: 0;
  }
}
.is-large {
  padding: 1rem 0.75rem;
}
</style>
